import '../filter_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.UnappliedFilterView extends Common.Dashboard.Filters.FilterView
  render: ->
    @$el.empty().append @template
      title: @_displayTitle()
    @

  _displayTitle: ->
    throw new Error 'Not implemented'
